<template>
  <!-- <el-container>
    <aside-nav />
    <el-main>
      <router-view></router-view>
    </el-main>
    <el-footer>
      <web-footer />
    </el-footer>
  </el-container> -->
  <el-container>
    <el-aside> 
      <el-menu :default-active="path" class="el-menu-vertical-demo" @select="handleSelect"
        background-color="#fff" text-color="#333" active-text-color="#3377FF" router>
        <div class="menu-logo">
          <!-- <img :src="require('@/assets/image/logo_menu.png')" alt="" class="logo"> -->
          <h1 class="title">瑞韬剧场</h1>
        </div>
        <div class="user-info" v-show="$store.state.user.showUser">
          <img :src="require('@/assets/image/head_pic.png')" alt="" class="user-pic">
          <span class="name">机智的弗洛里安兰斯伯爵</span>
          <span class="vip-tip">每天仅1元畅享全站影片</span>
          <div class="open-vip">立即开通</div>
        </div>
        <el-menu-item index="/home" v-show="!$store.state.user.showUser">
          <img v-if="path == '/home'" :src="require('@/assets/image/icon_shouye01.png')" alt="" class="icon-menu">
          <img v-else :src="require('@/assets/image/icon_shouye02.png')" alt="" class="icon-menu">
          <span>首页</span>
        </el-menu-item>
        <el-menu-item index="/history">
          <img v-if="path == '/history'" :src="require('@/assets/image/icon_history01.png')" alt="" class="icon-menu">
          <img v-else :src="require('@/assets/image/icon_history02.png')" alt="" class="icon-menu">
          <span>观看历史</span>
        </el-menu-item>
        <!-- <el-menu-item index="/collect">
          <img v-if="path == '/collect'" :src="require('@/assets/image/icon_shoucang01.png')" alt="" class="icon-menu">
          <img v-else :src="require('@/assets/image/icon_shoucang02.png')" alt="" class="icon-menu">
          <span>我的收藏</span>
        </el-menu-item> -->
        <!-- <div class="text-tip" v-show="!$store.state.user.showUser">特色频道</div>
        <el-menu-item index="/ancient" v-show="!$store.state.user.showUser">
          <img v-if="path == '/ancient'" :src="require('@/assets/image/icon_guzhuang01.png')" alt="" class="icon-menu">
          <img v-else :src="require('@/assets/image/icon_guzhuang02.png')" alt="" class="icon-menu">
          <span>古装</span>
        </el-menu-item>
        <el-menu-item index="/modern" v-show="!$store.state.user.showUser">
          <img v-if="path == '/modern'" :src="require('@/assets/image/icon_xiandai01.png')" alt="" class="icon-menu">
          <img v-else :src="require('@/assets/image/icon_xiandai02.png')" alt="" class="icon-menu">
          <span>现代</span>
        </el-menu-item>
        <el-menu-item index="/action" v-show="!$store.state.user.showUser">
          <img v-if="path == '/action'" :src="require('@/assets/image/icon_action01.png')" alt="" class="icon-menu">
          <img v-else :src="require('@/assets/image/icon_action02.png')" alt="" class="icon-menu">
          <span>动作</span>
        </el-menu-item>
        <el-menu-item index="/joker" v-show="!$store.state.user.showUser">
          <img v-if="path == '/joker'" :src="require('@/assets/image/icon_joke01.png')" alt="" class="icon-menu">
          <img v-else :src="require('@/assets/image/icon_joke02.png')" alt="" class="icon-menu">
          <span>搞笑</span>
        </el-menu-item>
        <el-menu-item index="/account" v-show="$store.state.user.showUser">
          <img v-if="path == '/account'" :src="require('@/assets/image/icon_setting01.png')" alt="" class="icon-menu">
          <img v-else :src="require('@/assets/image/icon_setting02.png')" alt="" class="icon-menu">
          <span>账号设置</span>
        </el-menu-item> -->
      </el-menu>
      <!-- <div class="code-contain">
          <img :src="require('@/assets/image/codeQR_pic.png')" alt="" class="code-pic">
          <div class="code-tip">扫一扫  手机观看更方便</div>
        </div> -->
    </el-aside>
    <el-container>
      <!-- <el-header>
         <aside-nav /> 
      </el-header> -->
      <el-main>
        <router-view></router-view>
      </el-main>
      <!-- <el-footer>
        <web-footer /> 
      </el-footer> -->
    </el-container>
  </el-container>
</template>

<script>
export default {
  data () {
    return {
      path: ''
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler (to, from) {
      console.log(to, 'to')
      this.path = to.path
      if (to.path == '/account') {
        this.$store.state.user.showUser = true
      } else {
        this.$store.state.user.showUser = false
      }
      }
    }
  },
  methods: {
    handleSelect (key, keyPath) {
      this.path = key
      console.log(key, keyPath)
    }
  },
  mounted () {
    // this.handleSelect()
  }
}
</script>

<style lang="scss" scoped>
.el-aside {
  width: 172px !important;
  height: 100vh;
  padding: 24px 10px;
  background-color: #fff;
  color: #333;
  border-right: 1px solid #f9f9f9;
  .code-contain{
    width: 152px;
    height: 175px;
    background-color: #fff;
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    left: 10px;
    bottom: 24px;
    .code-pic{
      width: 120px;
      height: 120px;
      margin-bottom: 10px;
    }
    .code-tip{
      color: #fff;
      opacity: 0.6;
      font-size: 12px;
      line-height: 15px;
    }
  }
}

.el-main {
  width: calc(100% - 172px);
  height: 100vh;
  padding: 0;
}
.el-menu-item{
  width: 154px;
  height: 60px;
  // padding-left: 0 !important;
  border-radius: 8px;
  padding-left: 16px!important;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .icon-menu{
    width: 18px;
    height: 18px;
    margin-right: 12px;
  }
  // &:nth-child(4){
  //   border-bottom: 1px solid #2E3033;
  // }
}
.el-menu-item:hover{
  background-color: rgba(67, 121, 243, 0.06) !important;
}
.el-menu{
  border: none;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .menu-logo{
    width:154px;
    // height: 24px;
    padding-left: 16px;
    margin-bottom: 18px;
    // padding: 0 16px;
    display: flex;
    justify-content: flex-start;
    .logo{
      width: 120px;
      height: 24px;
    }
    .title{
      font-size: 28px;
      color: #3377FF;
      margin: 0;
    }
  }
  .user-info{
    width:154px;
    padding-left: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 40px;
    .user-pic{
      width: 72px;
      height: 72px;
      border-radius: 50%;
      margin-bottom: 12px;
    }
    .name{
      color: #333;
      opacity: 0.6;
      margin-bottom: 20px;
    }
    .vip-tip{
      color: #D3AD74;
      margin-bottom: 8px;
    }
    .open-vip{
      width: 120px;
      height: 36px;
      background: linear-gradient(to right,#F5D9AC,#D3AD74);
      border-radius: 8px;
      color: #603E11;
      font-size: 14px;
      text-align: center;
      line-height: 36px;
    }
  }
  .text-tip{
    width:154px;
    padding-top: 24px;
    padding-left: 16px;
    margin:0px 0 12px 0;
    color: #999;
    font-size: 14px;
    line-height: 18px;
    border-top: 1px solid #999;
  }
}
</style>